import pie from "pistacja/plugin";
import TabsManager from "tabs-manager";
import revealContent from "reveal-content";
import usppModal from "pistacja/uspp-modal";

pie.plugin(function Playlist({ device, domain }) {
  // Handle Tabs.
  const tabs = TabsManager();

  // Playlist description.
  revealContent({
    displayHeight: 92,
    resetOnResize: true,
    targetClass: ".pie-playlist-preview-description .text",
  });

  // USPP modal.
  usppModal("#usppModal", domain);

  // Select active tabs if user go from mobile to desktop.
  device({
    onDesktop() {
      tabs.initialize();
    },

    onMobile() {
      tabs.initialize();
    },
  });
});
